import React, { useState, useEffect } from 'react';
import {
    Dialog, DialogTitle, DialogContent, DialogActions,
    Button, TextField, Box, Typography
} from '@mui/material';

const AssignLicensesDialog = ({
                                  open,
                                  onClose,
                                  onSubmit,
                                  loading,
                                  orgName,
                                  orgCode
                              }) => {
    const [licenseCount, setLicenseCount] = useState('');
    const [error, setError] = useState('');

    useEffect(() => {
        if (open) {
            setLicenseCount('');
            setError('');
        }
    }, [open]);

    const handleAssign = () => {
        if (!licenseCount || isNaN(Number(licenseCount)) || Number(licenseCount) <= 0) {
            setError('Enter a valid number of licenses');
            return;
        }
        setError('');
        onSubmit({ org_code: orgCode, license_count: Number(licenseCount) });
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle sx={{ color: '#ff6468', fontWeight: 'bold', textAlign: 'center' }}>
                Assign Licenses to {orgName}
            </DialogTitle>
            <DialogContent>
                <Typography sx={{ textAlign: 'center', fontSize: '17px', mb: 2 }}>
                    Input the number of licenses you wish to assign to this client.<br/>
                    <b>Please double check before clicking ASSIGN</b>. Once assigned, your client will be able to access these licenses and use the assessments you have linked to their account.
                </Typography>
                <Box sx={{ my: 2 }}>
                    <TextField
                        label="Number of Licenses"
                        type="number"
                        value={licenseCount}
                        onChange={e => setLicenseCount(e.target.value)}
                        error={!!error}
                        helperText={error}
                        fullWidth
                        autoFocus
                        inputProps={{ min: 1 }}
                    />
                </Box>
            </DialogContent>
            <DialogActions>
                <Box sx={{ display: 'flex', width: '100%',alignItems:'center', justifyContent: 'center', gap: 2, mb: 3 }}>
                <Button onClick={onClose} variant="outlined"  sx={{
                    borderRadius: '20px',
                    minWidth: '120px',
                    fontWeight: 'bold',
                    borderColor: '#0097b2',
                    color: '#0097b2',
                }}>
                    Cancel
                </Button>
                    <Button
                        variant="contained"
                        onClick={handleAssign}
                        sx={{
                            backgroundColor: '#ff6468', color: '#fff', borderRadius: '20px',
                            fontWeight: 'bold', minWidth: '110px'
                        }}
                        disabled={loading}
                    >
                        {loading ? 'Assigning...' : 'Assign'}
                    </Button>
            </Box>
            </DialogActions>
        </Dialog>
    );
};

export default AssignLicensesDialog;
